import React from 'react';
import './TrustedPartners.css';

const TrustedPartners = () => {
    const partners = [
        { name: 'S.V.A Rikkon Luber Pvt. Ltd.' },
        { name: 'Dynamic Motors India Pvt. Ltd.' },
        { name: 'SRP Gears Pvt. Ltd.' },
        { name: 'Ormed Medical Technologist' }
    ];

    return (
        <section className="partners">
            <div className="container partners-container">
                <h2 className="partners-title">Trusted by Industrial <br /> Clients</h2>
                <p className="partners-subtitle">We proudly support manufacturing and engineering companies with precision CNC and machining solutions.</p>

                <div className="partners-grid">
                    {partners.map((partner, index) => (
                        <div key={index} className="partner-card">
                            <h4>{partner.name}</h4>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default TrustedPartners;
